<template>
  <div class="message">
    <Modal
      v-model="xtmessage"
      width="800px"
      class-name="vertical-center-modal"
      @on-cancel="cancel"
      @on-ok="okList"
    >
      <div class="chat-box">
        <div>
          <div class="left"></div>
          <div class="middle">{{ listTop }}-{{ list_mass.perName }}</div>
          <div class="right"></div>
        </div>
        <div id="data_list">
          <Scroll class="msg-box" ref="msg-box" :on-reach-bottom="handleReachBottom">
            <!-- {{ data_list }} -->
            <!-- <div v-for="(i, index) in data_list" :key="index" class="msg"></div> -->
            <div v-for="(i, index) in data_list" :key="index" class="msg">
              <div class="user-head">
                <img src="../../../../public/mobileImg/service.png" alt="" />
              </div>
              <div class="user-msg">
                <span class="left">{{ i.sendText }}</span>
              </div>
            </div>
          </Scroll>
        </div>

        <!-- <Table :columns="columns1" :data="data_list.list"></Table>
        <Page
          :total="thone"
          :page-size="pageSize"
          :current="pageNo"
          show-elevator
          show-total
          @on-change="pageChange"
          class="page"
        /> -->
        <div class="input-box"></div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "message",
  data() {
    return {
      //   xtmessage: true,
      livetitle: "系统消息",
      pageNo: 1,
      pageSize: 10,
      data_list: [],
      thone: 0,
      listTop: "",
      columns1: [
        {
          title: "发布信息",
          key: "sendText",
        },
        {
          title: "时间",
          key: "sendTime",
        },
      ],
    };
  },
  props: {
    list_mass: {
      type: Object,
      required: false,
    },
    xtmessage: Boolean,
  },
  mounted() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.listTop = userInfo.name
      ? userInfo.name
      : userInfo.account.slice(0, 3) +
        "****" +
        userInfo.account.slice(userInfo.account.length - 4);
    this.getNews();
  },
  methods: {
    handleReachBottom() {
      let _this = this;
      return new Promise((resolve) => {
        setTimeout(() => {
          if (_this.pageSize == _this.data_list.length) {
            _this.pageNo++;
            _this.getNews();
          }
          resolve();
        }, 2000);
      });
    },
    cancel() {
      this.xtmessage = false;
      this.$emit("modalCxt", this.xtmessage);
    },
    okList() {
      this.xtmessage = false;
      this.$emit("modalCxt", this.xtmessage);
    },
    getNews() {
      var data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        perId: this.list_mass.perId,
        userId: this.$store.state.userId,
        groupId: this.list_mass.groupId,
      };
      this.$apis.manage.getNewsList(data).then((res) => {
        // this.data_list = res.data.list;
        res.data.list.map((res) => {
          this.data_list.push(res);
        });
        var totken = res.data.total;
        this.thone = Number(totken);
      });
    },
    //分页的事件
    pageChange(current) {
      if (current) {
        this.pageNo = current;
      }
      this.getNews();
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
.message {
}
.page {
  margin: 30px 0px;
}
/deep/ .v-transfer-dom {
  height: 0px;
}
/deep/ .ivu-modal-body {
  height: 600px;
  padding: 0px !important;
}
/deep/.ivu-modal-footer {
  display: none;
}
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}

.chat-box {
  margin: 0 auto;
  background: #fafafa;
  position: absolute;
  height: 100%;
  width: 100%;
  // max-width: 700px;
}
header {
  position: fixed;
  width: 100%;
  height: 4rem;
  max-width: 700px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #333333;
  font-size: 1rem;
}
.left {
  padding-left: 10px;
  width: 50px;
}
.middle {
  width: 100%;
  text-align: center;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #111111;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 20px;
}
.right {
  width: 50px;
}
.msg-box {
  position: absolute;
  height: auto;
  width: 100%;
  overflow-y: scroll;
  background: #f6f6f6;
}
.input-box {
  padding: 0 0.5rem;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 3.5rem;
  background: #fafafa;
  box-shadow: 0 0 5px #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/.ivu-scroll-container {
  height: 473px !important;
}
.msg-box {
  position: absolute;
  // height: calc(100% - 7.5rem);
  width: 100%;
  // margin-top: 4rem;
  // overflow-y: scroll;
  background: #f6f6f6;
  .msg {
    width: 95%;
    min-height: 2.5rem;
    margin: 1rem 0.5rem;
    position: relative;
    display: flex;
    justify-content: flex-start !important;
    .user-head {
      min-width: 2.5rem;
      width: 20%;
      width: 2.5rem;
      height: 2.5rem;
      background: #f1f1f1;
      display: flex;
      justify-content: center;
      border-radius: 4px;
      align-items: center;
      margin: auto 8px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      // position: absolute;
    }
    .user-msg {
      width: 80%;
      // position: absolute;
      word-break: break-all;
      position: relative;
      z-index: 5;
      .title {
        font-size: 0.1rem;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
      }
      span {
        display: inline-block;
        padding: 0.5rem 0.7rem;
        border-radius: 0.5rem;
        margin-top: 0.2rem;
        font-size: 0.88rem;
      }
      .left {
        background: white;
        animation: toLeft 0.5s ease both 1;
        width: auto;
      }
      .right {
        background: #53a8ff;
        color: white;
        animation: toright 0.5s ease both 1;
      }
      @keyframes toLeft {
        0% {
          opacity: 0;
          transform: translateX(-10px);
        }
        100% {
          opacity: 1;
          transform: translateX(0px);
        }
      }
      @keyframes toright {
        0% {
          opacity: 0;
          transform: translateX(10px);
        }
        100% {
          opacity: 1;
          transform: translateX(0px);
        }
      }
    }
  }
}
</style>
//
